import * as Yup from 'yup'

import { LOCATION_SELECTION_MESSAGE } from '../hookForm/validateLocationSelection'

const locationSchema = {
  location: Yup.string()
    .nullable()
    .required('This field is required')
    .test(
      'selected-from-suggestions',
      LOCATION_SELECTION_MESSAGE,
      function selectedFromSuggestions() {
        const { latitude, longitude } = this.parent
        return latitude != null && longitude != null
      },
    ),
  latitude: Yup.number().nullable(),
  longitude: Yup.number().nullable(),
}

export default locationSchema
